import type { FaireProductEntity } from "../../entity_types/product";

export const p_sqk8xrhr75: FaireProductEntity = {
  token: "p_sqk8xrhr75",
  type: "product",
  name: "Women's Set: Cross-back  Bra And Criss-cross Waist Leggings",
  brandToken: "b_fj2hyk2c4h",
  brandName: "Sodalemon",
  imageUrl:
    "https://cdn.faire.com/fastly/69ab45cffa8c19d2cd22cffdfb6312c9622db2aff27f446369eb1f362884b3f1.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6170d342722c52d49cfebd92f63c3c3cb1b572d35c866e49301fb8bb67f64cc1.png",
    "https://cdn.faire.com/fastly/2143c94ec6a6528c00f934a9e4df0565bc3294319529b73df53accf5af77cffa.png",
    "https://cdn.faire.com/fastly/b39b8748d53c5b38a84b2b29865ceaaa13abd5d3926a87a2ba0e70a32267a96b.png",
    "https://cdn.faire.com/fastly/fc8b284e928e2f76a414a4dec335396beb8333551b4b0c6d2843dff8786c8006.jpeg",
    "https://cdn.faire.com/fastly/98862d5a993bf0a5251980d472f0b4596e94d72669ec0ec268473e98c4bd162f.jpeg",
    "https://cdn.faire.com/fastly/d8cbcfcdd8dd03b6fac5eb41bab9566522e3e8bf4a2e6e58c12e48de87d448d3.png",
    "https://cdn.faire.com/fastly/3de3ab448973250e84fed4d09137b7a468b4f5c90930e4efe30e58e76a26b90e.png",
    "https://cdn.faire.com/fastly/b5e063aab5ca78f6f1549d6f03398c0cbde8e6624c6ea342227efa341a1b5602.png",
    "https://cdn.faire.com/fastly/e3f26cf40100620ac1f2e4df85a7a57a917eca14400bc8275692eddaaa05ff9e.png",
  ],
  priceDollars: 29.53,
  description:
    "[Product Features]\nType:Women's Set: Cross-back  Bra And Criss-cross Waist Leggings – gentle-minimal active set\nKey Design: \nTop: slim straps + square-neck seam gently gather and lift; 20 cm crop clears high-rise waist; built-in removable pads swap support for lounge. \nLeggings: 9 cm cross-waist band sculpts core and creates hourglass optic; 7/8 ankle-skimming inseam clears sneakers; zero front-rise seam kills camel-toe; heart-shaped back seam lifts the peach.\n[Fabric]\nComposition: 75 % nylon, 25 % elastana naked-feel knit, 220 g\nCharacteristics: 4-way stretch (1 : 1.7) rebounds after deep squats; matte face looks luxe, not shiny; hydrophobic yarns wick sweat in < 2 min; no side seams for zero chafe; UPF 50+ for outdoor flows\nCare: Machine-wash cold, gentle cycle, inside-out, no softener; air-dry flat; no bleach; cool iron only\n[Applicable Occasions]\nYoga flows, Pilates core, coffee dashes; wear as a set at 18–30 °C or split the bra under a blazer / the leggings with an oversized knit – the square neck keeps the look gentle while the cross waist keeps the silhouette snatched for athleisure, studio-active or casual-minimal looks.",
  tags: [],
  msrpDollars: 59.06,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:41.785Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
